<template lang="html">
  <div class="province-F">
    <div class="tabArea">
      <div class="seekArea">
        <el-form label-width="80px" :inline="true" class="demo-form-inline">
          <el-form-item label="状态">
            <el-radio-group v-model="params.sbstatus" size="small">
              <el-radio-button label="全部数据">全部数据</el-radio-button>
              <el-radio-button label="全部上报">全部上报</el-radio-button>
              <el-radio-button label="部分上报">部分上报</el-radio-button>
              <el-radio-button label="未上报">未上报</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="省局">
            <el-input
              size="small"
              v-model="params.pname"
              style="width: 200px"
              placeholder="输入省局名称模糊查询"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="tabDats" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="pname" label="省局" min-width="100" align="center"> </el-table-column>
        <el-table-column prop="sbstatus" label="状态" align="center"> </el-table-column>
        <el-table-column prop="total" label="出版单位数量" width="190" align="center"> </el-table-column>
        <el-table-column prop="nonum" label="未上报数量" align="center"> </el-table-column>
        <el-table-column prop="wsnum" label="待审" align="center"> </el-table-column>
        <el-table-column prop="ysnum" label="已审" align="center"> </el-table-column>
      </el-table>

      <!-- <div class="pageCage" v-if="params.pgAll > 1">
        <el-pagination @current-change="pageSent" :current-page='params.no' layout="prev, pager, next"
          :page-count="params.pgAll">
        </el-pagination>
      </div> -->
    </div>
  </div>
</template>

<script>
import { listAdminAuditQuery } from "@/api/adminRole/adminRole";
export default {
  data() {
    return {
      tabDatsAll: [],
      tabDats: [],
      params: {
        sbstatus: "全部数据",
      },
    };
  },
  watch: {
    params: {
      deep: true, //实现深度监听
      handler(v) {
        this.filterTableData();
      },
    },
  },
  methods: {
    tabSeek: function () {
      listAdminAuditQuery({
        type: 2,
      })
        .then((response) => {
          // console.log('response=',JSON.stringify(response));
          this.tabDatsAll = response.adminAuditList;
          this.filterTableData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 页面数据筛选
    filterTableData: function () {
      let qData = this.tabDatsAll;
      let qName = this.params.pname;
      let qSbstatus = this.params.sbstatus;
      // 名称查询
      if (qName) {
        let itemName;
        qData = qData.filter(function (item) {
          itemName = item.pname || "";

          if (itemName.indexOf(qName) > -1) {
            return true;
          }
          return false;
        });
      }
      if (qSbstatus && qSbstatus != "全部数据") {
        let itemName;
        qData = qData.filter(function (item) {
          itemName = item.sbstatus || "";

          if (itemName.indexOf(qSbstatus) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = qData;
    },
  },

  created: function () {
    this.tabSeek();
  },
};
</script>

<style lang="scss" scoped>
.province-F {
  padding: 9px;

  .ttBar {
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    font-size: 14px;
    padding: 0 20px;
    color: #666666;
    font-weight: bold;
  }

  .tabArea {
    margin-top: 12px;

    .seekArea {
      margin-bottom: 12px;
      overflow: hidden;

      .selectBox {
        padding-left: 10px;
        float: left;
      }

      .el-input {
        width: 120px;

        input {
          border-radius: 0px;
        }
      }
    }

    .pageCage {
      text-align: center;
      margin: 30px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// adminDzauditQuery.vue?6bf347b8